import React from "react";
import { Flex } from "antd";
import { Text } from "../../Atomics/Text";
import Theme from "../../../../styles/Theme/Theme";
import styled from "styled-components";
import { IconWrapper } from '@synergy/icons';

const ChartLegendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Theme.spacing['s02']};
  border: 1.5px solid ${Theme.color["neutral-3"]};
  border-radius: ${Theme.radius['lg']};
  padding: 10px 10px;

  > div {
    > div {
      height:8px;
      width: 8px;
    }
  }
`;


export const ChartLegendComponent = ({ data, props }) => {
  // Renderiza o componente Widget com os dados e propriedades necessários
  return (
    <ChartLegendWrapper className={props?.className}>
      {data?.map((legend, index) => {
        return (
          <Flex align="center" horizontal="true" key={index}>
            {legend?.circleColor ? (
              <IconWrapper $bgColor={legend?.circleColor} $bgsize="10px"/>
            ) : null}
            <Text
              $fontColor="coolgray-12"
              $fontSize="text_xs"
              $weight="medium"
              $marginLeft={legend?.circleColor ? "s03" : "0"}
            >
              {legend?.label}
            </Text>
          </Flex>
        );
      })}
    </ChartLegendWrapper>
  );
};
